@let isHorizontalLabel = labelDirection === 'horizontal';

<div class="flex flex-wrap items-end justify-between gap-4" [ngClass]="className">
  <form
    class="flex items-center space-x-4"
    [formGroup]="form"
    [ngClass]="{ invisible: !alwaysShowSection && !versionOptions.length }"
  >
    <div
      class="relative flex text-sm"
      [ngClass]="{ 'items-center': isHorizontalLabel, 'flex-col': !isHorizontalLabel }"
    >
      <div
        [ngClass]="{
          'mr-2': isHorizontalLabel,
          'mb-1': !isHorizontalLabel,
        }"
        class="text-xs"
      >
        Protocol Version
      </div>
      <div class="flex items-center text-sm">
        @if (!isVersionControlEditable) {
          <ng-select
            #versionDropdown
            id="protocolVersion"
            class="custom-dropdown-options w-56 tabular-nums"
            placeholder="Select Protocol Version"
            formControlName="protocolVersion"
            bindLabel="label"
            bindValue="value"
            [ngClass]="{ 'editable-protocol-version': isVersionControlEditable }"
            [clearable]="false"
            [searchable]="false"
            [items]="versionOptions"
          >
            @for (item of versionOptions; track item; let index = $index; let first = $first) {
              <ng-option [value]="item.value">
                {{ item.label }}
              </ng-option>
            }

            <ng-template ng-footer-tmp class="flex flex-col">
              <div class="items-wrapper grow">
                @for (item of versionOptions; track item; let index = $index; let first = $first) {
                  <ng-option>
                    @if (!first && index === 1) {
                      <div class="mb-2 ml-2 mr-2 mt-1 h-1 border-b border-aux-gray-darkest"></div>
                    }

                    <div
                      class="relative flex cursor-default select-none justify-between py-2 pl-2 text-gray-900 hover:bg-aux-gray-light"
                      [ngClass]="{
                        'ng-option-selected': form.value.protocolVersion === item.value,
                      }"
                      (click)="
                        form.controls.protocolVersion.setValue(item.value); versionDropdown.close()
                      "
                    >
                      <div class="flex-1">
                        {{ item.label }}
                      </div>
                    </div>
                  </ng-option>
                }
              </div>
            </ng-template>
          </ng-select>
        }
        @if (isVersionControlEditable && form.controls.protocolVersion) {
          <aux-editable-list-dropdown
            [dropdownFormControl]="form.controls.protocolVersion"
            [id]="'protocolVersion'"
            [items]="enhancedVersionList()"
            [classList]="'w-60 tabular-nums'"
            (edit)="editProtocolVersion.emit($event)"
            (delete)="deleteProtocolVersion.emit($event)"
          />
        }
      </div>
    </div>

    @if (!hideAmendment) {
      <aux-button
        label="Amendment"
        variant="secondary"
        [disabled]="
          isAmendmentDisabled || isPatientsFinalized() || !userHasUpdateProtocolEntryPermission()
        "
        [auxTooltip]="noPermissionTooltip() || patientTrackerLockedTooltip()"
        [onClick]="onCreateAmendment"
        icon="Plus"
        [class.mt-3]="!isHorizontalLabel"
      />
    }

    <aux-site-budget-cost-type-dropdown
      formControlName="siteBudgetCostType"
      [horizontalLabel]="isHorizontalLabel"
      [filterCostOption]="filterCostOption()"
    />

    <aux-patient-group-dropdown
      formControlName="patientGroup"
      [horizontalLabel]="isHorizontalLabel"
      [isVisitCostSelected]="isVisitCostSelected()"
    />

    @if (
      showDiscontinuationRate() && form.value.siteBudgetCostType === siteCostType.PATIENT_VISITS
    ) {
      <aux-discontinuation-rate-input
        #discontinuationRateInput
        class="block w-60"
        [patientGroup]="form.value.patientGroup!"
        [protocolVersionId]="form.value.protocolVersion!"
        [disabled]="!editMode()"
        [auxTooltip]="!editMode() ? 'Click edit to update.' : ''"
      />
    }
  </form>

  @if (template) {
    <div class="flex-grow">
      <ng-container *ngTemplateOutlet="template" />
    </div>
  }
</div>
